export class OrderPaymentMessage {
  amount: number

  constructor(amount: number) {
    this.amount = amount
  }
}
  